<template>
  <div class="edit-barrier-doors">
    <div class="edit-barrier-doors__header">
      <h2 class="edit-barrier-doors__title">
        <v-icon left small>mdi-door-open</v-icon>
        Двери
      </h2>
      <v-btn
        color="primary"
        class="text-none"
        dark
        rounded
        :disabled="isButtonDisabled"
        @click="newDoorDialog = true"
      >
        <v-icon left>mdi-plus</v-icon>
        Создание двери
      </v-btn>
    </div>

    <v-dialog v-model="newDoorDialog" width="500" content-class="dialog-border-radius" persistent>
      <BaseDeleteModal
        :active.sync="newDoorDialog"
        @close="newDoorDialog = false"
        @submit="newDoor()"
        messageTitle="Создание двери"
        messageText="Подтверждая, вы создадите шлагбауму новую дверь."
        confirmText="Создать"
        cancelText="Отмена"
      />
    </v-dialog>

    <div class="edit-barrier-doors__card mt-3">
      <v-data-table
        class="edit-barrier-doors__table"
        :headers="headersDoors"
        :items="doors"
        hide-default-footer
      >
        <template v-slot:item.name="{ item }">
          <v-text-field
            v-model="item.name"
            outlined
            dense
            hide-details
            :rules="[() => !!item.name || 'Обязательное поле']"
          />
        </template>
        <template v-slot:item.isActive="{ item }">
          <v-checkbox
            v-model="item.is_active"
            label="Отображение"
            hide-details
            dense
            color="primary"
          />
        </template>
        <template v-slot:item.separate="{ item }">
          <v-checkbox
            v-model="item.separate"
            label="Отдельно в приложении"
            hide-details
            dense
            color="primary"
          />
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.doornum === 2"
                icon
                small
                v-bind="attrs"
                v-on="on"
                class="edit-barrier-doors__delete-btn"
                @click.stop="$set(deleteDialog, item.id, true)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
          <v-dialog v-model="deleteDialog[item.id]" width="500" content-class="dialog-border-radius" persistent>
            <BaseDeleteModal
              :active.sync="deleteDialog[item.id]"
              @close="$set(deleteDialog, item.id, false)"
              @submit="removeDoor(item.doornum, item.id)"
              messageTitle="Удалить Реле (дверь)?"
              messageText="Подтверждая, вы удалите дверь из списка."
              confirmText="Удалить"
              cancelText="Отмена"
              confirmColor="error"
            />
          </v-dialog>
        </template>
      </v-data-table>
      <div class="edit-barrier-doors__actions">
        <v-btn
          color="primary"
          class="text-none"
          rounded
          @click="save()"
        >
          <v-icon left>mdi-content-save-outline</v-icon>
          Сохранить
        </v-btn>
        <v-btn
          color="primary"
          outlined
          class="text-none"
          rounded
          @click.prevent="returnBarrier()"
        >
          <v-icon left>mdi-close</v-icon>
          Отменить
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseDeleteModal from '@/components/BaseDeleteModal';

export default {
  name: 'Doors',
  components: { BaseDeleteModal },
  props: ['returnBarrier'],
  data: () => ({
    doors: [],
    infoDoorOpen: [],
    jointDataDoors: [],
    deleteDialog: {},
    doornum: null,
    isDisabledDoorOpen: false,
    newDoorDialog: false,
    headersDoors: [
      { text: 'id', value: 'id' },
      { text: 'Отображение двери', value: 'isActive' },
      { text: 'Отображение отдельной строкой', value: 'separate' },
      { text: 'Номер двери', value: 'doornum' },
      { text: 'Название', value: 'name', width: 300 },
      { text: '', value: 'actions', align: 'center' },
    ],
  }),
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      barrierEdit: 'Barriers/barrierEdit',
    }),
    isButtonDisabled () {
      if (this.barrierEdit?.barrier?.manufacturer === 'Rubetek') {
        return this.doors.length >= 2;
      }
      return this.doors.length >= 1;
    },
  },
  methods: {
    ...mapActions({
      getDoorsBarrier: 'Door/getDoorsBarrier',
      updateDoorBarrier: 'Door/updateDoorBarrier',
      deleteDoorBarrier: 'Door/deleteDoorBarrier',
      removeDoorBarrier: 'Door/removeDoorBarrier',
      newDoorBarrier: 'Door/newDoorBarrier',
    }),
    save () {
      const savePromises = this.doors.map(item => {
        return this.updateDoorBarrier({
          id: this.$route.params.id,
          doornum: item.doornum,
          name: item.name,
          separate: item.separate,
          is_active: item.is_active,
        });
      });

      Promise.all(savePromises)
        .then(() => {
          this.getData();
          this.$flash_success('Все изменения успешно сохранены');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при сохранении некоторых данных');
        });
    },
    removeDoor (doornum, id) {
      this.removeDoorBarrier({
        id: this.$route.params.id,
        doornum: doornum,
      })
        .then(() => {
          this.$flash_success('Дверь удалена.');
          this.getData();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении двери.');
        });
      this.deleteDialog[id] = false;
    },
    newDoor () {
      const nextDoorNum = this.doors.length > 0
        ? Math.max(...this.doors.map(door => door.doornum)) + 1
        : 1;

      this.newDoorBarrier({
        id: this.$route.params.id,
        doornum: nextDoorNum,
      })
        .then(() => {
          this.$flash_success('Дверь успешно создана.');
          this.getData();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при создании двери.');
        });
    },
    getData () {
      this.getDoorsBarrier(this.$route.params.id)
        .then(doors => {
          this.doors = doors;
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Не удалось получить настройки дверей');
          }
        });
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.edit-barrier-doors__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.edit-barrier-doors__title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  display: flex;
  align-items: center;
}

.edit-barrier-doors__card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  overflow: hidden;
}

.edit-barrier-doors__table {
  border: none;
}

.edit-barrier-doors__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.edit-barrier-doors__delete-btn {
  min-width: 32px;
  width: 32px;
}

::v-deep .dialog-border-radius {
  border-radius: 12px;
}
</style>
